import React from 'react'

const Juego = ({id, numUnidad, titulo, seleccionado, bullet, onSeleccionar }) => 
    <div className={ `unidadIndice${numUnidad}${seleccionado ? " activa" : ""}`} onClick={ () => onSeleccionar() } >
        { bullet && <div className="bullet"></div> }
        <span dangerouslySetInnerHTML={{ __html: titulo }} />
    </div>
export default Juego